<template>
<div id="navigation">
  <h3 @click="homeRD">Emily Elder</h3>
  <div @click="workPageRd" class="btn">
    <h2>View my work</h2>
    <i class="far fa-eye"></i>
  </div>
  <div @click="hamClick" class="hamburger">
    <div class="T"></div>
    <div class="M"></div>
    <div class="B"></div>
  </div>
  <div class="links">
    <ul>
      <router-link class="routerLink" to="/home" @click="hamClick">Home</router-link>
      <router-link class="routerLink" to="/home/resumeShowcase" @click="hamClick">My Resume</router-link>
      <router-link class="routerLink" to="/home/workShowcase" @click="hamClick">My Work</router-link>
      <router-link class="routerLink" to="/contact" @click="hamClick">Contact Me</router-link>
    </ul>
  </div>
</div>
</template>

<script src="./Navigation.js"></script>

<style src="./Navigation.scss" lang="scss" scoped></style>
